var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2128 1.71224C14.2277 1.53524 14.4867 1.53524 14.5016 1.71223L16.1553 21.3193C16.1876 21.702 16.2872 22.0759 16.4495 22.4238L22.0468 34.4225C22.122 34.5836 21.8968 34.7124 21.7961 34.5659L15.5512 25.4888C14.9752 24.6517 13.7391 24.6517 13.1632 25.4888L6.91829 34.5659C6.8175 34.7124 6.59238 34.5836 6.66755 34.4225L12.2649 22.4238C12.4272 22.0759 12.5268 21.702 12.5591 21.3193L14.2128 1.71224Z",
    fill: "url(#paint0_linear_899_2694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5713 21.5486L12.8942 17.1142C12.8999 17.0358 13.0088 17.0213 13.0349 17.0954L16.2367 26.1916C16.2642 26.2697 16.1605 26.3254 16.1106 26.2594L12.5858 21.5976C12.5752 21.5835 12.57 21.5661 12.5713 21.5486Z",
    fill: "#A0A0A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.62598,
    y: 30.7734,
    width: 1.01495,
    height: 0.348848,
    transform: "rotate(135 2.62598 30.7734)",
    fill: "url(#paint1_linear_899_2694)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.01495,
    height: 0.348848,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 26.459 30.7734)",
    fill: "url(#paint2_linear_899_2694)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 0.589385,
    height: 0.348848,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0.696289 32.7031)",
    fill: "url(#paint3_linear_899_2694)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 0.146293,
    height: 0.348848,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 0.24707 33.1523)",
    fill: "url(#paint4_linear_899_2694)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3887,
    y: 32.7031,
    width: 0.589385,
    height: 0.348848,
    transform: "rotate(-135 28.3887 32.7031)",
    fill: "url(#paint5_linear_899_2694)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.75,
    y: 33.0645,
    width: 0.0862283,
    height: 0.348848,
    transform: "rotate(-135 28.75 33.0645)",
    fill: "url(#paint6_linear_899_2694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6938 29.8723L20.1268 24.3053C18.9671 23.1456 18.2132 21.6423 17.9774 20.0193L15.7363 4.5957",
    stroke: "url(#paint7_linear_899_2694)",
    strokeWidth: 0.362315
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17536 29.8723L8.74234 24.3053C9.90203 23.1456 10.656 21.6423 10.8918 20.0193L13.1328 4.5957",
    stroke: "url(#paint8_linear_899_2694)",
    strokeWidth: 0.362315
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.76177 15.1661L10.9873 8.27246",
    stroke: "url(#paint9_linear_899_2694)",
    strokeWidth: 0.362315
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M20.0256 20.5276L19.1064 15.0127",
    stroke: "url(#paint10_linear_899_2694)",
    strokeWidth: 0.362315
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M18.1872 11.1828L17.8809 9.03809",
    stroke: "url(#paint11_linear_899_2694)",
    strokeWidth: 0.362315
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M12.3663 2.14473L12.5195 1.22559",
    stroke: "url(#paint12_linear_899_2694)",
    strokeWidth: 0.362315
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_2694",
    x1: 27.1623,
    y1: 49.9352,
    x2: 0.957508,
    y2: 11.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_899_2694",
    x1: 3.13345,
    y1: 30.7734,
    x2: 3.13345,
    y2: 31.1223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_899_2694",
    x1: 0.507473,
    y1: 0,
    x2: 0.507473,
    y2: 0.348848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_899_2694",
    x1: 0.294693,
    y1: 0,
    x2: 0.294693,
    y2: 0.348848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_899_2694",
    x1: 0.0731466,
    y1: 0,
    x2: 0.0731466,
    y2: 0.348848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_899_2694",
    x1: 28.6834,
    y1: 32.7031,
    x2: 28.6834,
    y2: 33.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_899_2694",
    x1: 28.7931,
    y1: 33.0645,
    x2: 28.7931,
    y2: 33.4133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_899_2694",
    x1: 22.247,
    y1: 4.5957,
    x2: 22.247,
    y2: 29.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_899_2694",
    x1: 8.99664,
    y1: 5.20847,
    x2: 6.62217,
    y2: 29.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_899_2694",
    x1: 7.4639,
    y1: 5.20863,
    x2: 5.08943,
    y2: 29.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_899_2694",
    x1: 22.3235,
    y1: 10.5701,
    x2: 24.6979,
    y2: 35.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_899_2694",
    x1: 21.0979,
    y1: 4.13596,
    x2: 23.4723,
    y2: 28.7998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_899_2694",
    x1: 9.76209,
    y1: -5.20845,
    x2: 7.38762,
    y2: 19.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBCBCB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayRocket);
export default __webpack_public_path__ + "static/media/gray-rocket.3528aa957eb5ee4ac3612345b6c7f4f5.svg";
export { ForwardRef as ReactComponent };